/**
 * Capture device/browser info at a point in time (e.g. when user starts analysis from landing).
 * Used for live testing and analytics to know which device was used for the skin analysis.
 */

/**
 * @returns {{
 *   user_agent: string,
 *   platform: string,
 *   language: string,
 *   screen_width: number,
 *   screen_height: number,
 *   device_type: 'mobile'|'tablet'|'desktop',
 *   captured_at: string (ISO)
 * }}
 */
export function captureDeviceInfo() {
  const ua = typeof navigator !== 'undefined' ? navigator.userAgent : '';
  const platform = typeof navigator !== 'undefined' ? (navigator.platform || navigator.userAgentData?.platform || '') : '';
  const language = typeof navigator !== 'undefined' ? (navigator.language || '') : '';
  const scr = typeof window !== 'undefined' && window.screen;
  const w = scr ? scr.width : 0;
  const h = scr ? scr.height : 0;

  let device_type = 'desktop';
  if (typeof window !== 'undefined' && window.matchMedia) {
    if (window.matchMedia('(max-width: 767px)').matches) device_type = 'mobile';
    else if (window.matchMedia('(max-width: 1024px)').matches) device_type = 'tablet';
  }
  // Fallback from userAgent if matchMedia not available
  if (device_type === 'desktop' && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua))
    device_type = /iPad|Tablet/i.test(ua) ? 'tablet' : 'mobile';

  return {
    user_agent: ua,
    platform: String(platform),
    language: String(language),
    screen_width: Number(w) || 0,
    screen_height: Number(h) || 0,
    device_type,
    captured_at: new Date().toISOString(),
  };
}
